/**
 * Theme Scripts Entrypoint.
 *
 * This file serves as a place to import all of the JS that will eventually be bundled by Webpack to form the production-ready version.
 * 
 * TODO:
 * 
 * - Replicate all functionality here into React components.
 * - For global things like the scroll smoother, think about how to split between ready/load-critical events
 * 
 * - For global scroll smoother stuff, think about how to encapsulate sticky things
 * - Abstract out "color-changing magic" things like the header and subnavss
 *
 * @author Nick Patterson <nick@fifteen4.com>
 */

/** Dependencies -------------------------------------------- */

import SmoothScroll from './includes/smooth-scroll'
import Slider from './includes/slider'

import header from './includes/header'
import filter from './includes/filter'
import callout from './includes/callout'
import superhero from './includes/superhero'
import scrollIndicator from './includes/scroll-indicator'
import preloader from './includes/preloader'
import accordion from './includes/accordion'
import banner from './includes/banner'
import subnav from './includes/subnav'
import hero from './includes/hero'

/** Initialization ------------------------------------------ */

const smoothScroll = new SmoothScroll( 'smooth-scroll' )
const slider = new Slider( 'c-slider', 'c-slide', {} )

function onDomContentLoaded() {

    slider.init()
    filter.init( { selector: '[data-filter]' } )
    header.init( { selector: '[data-header]' } )
    accordion.init( { className: 'c-accordion' } )
    banner.init( { className: 'c-banner' } )
    subnav.init( { className: 'c-subnav' } )
    hero.init( { className: 'c-hero' } )
}

function onPageShow() {

    smoothScroll.init()
    slider.animate()
    callout.init( { className: 'c-callout' } )

    superhero.init(
        {
            className: 'c-superhero',
            config: {
                animationPath : null
            }
        }
    )

    scrollIndicator.init( { selector: '.c-scroll-indicator.is-global' } )
    preloader.init( { selector: '.c-preloader' } )
}

if ( document.readyState !== 'loading' ) {
    onDomContentLoaded()
}
else {
    window.addEventListener( 'DOMContentLoaded', onDomContentLoaded )
}

window.addEventListener( 'pageshow', onPageShow )
